import React, { useEffect, useState } from "react";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { Button, Box, TextField } from "@mui/material";
import dayjs from "dayjs";
import GraphDashboardActions from "../../../Actions/GraphDashboardActions";
import { useGlobalSpinnerActionsContext } from "../../../Context/GlobalSpinnerContext";
import { useLanguageContext } from "../../../Context/LanguageContext";
import commonUtils from "../../../helpers/commonUtils";

export default function ChartsDateSelector({
  keyOfChart,
  selectedEquipmentGroupId,
}) {
  const setGlobalSpinner = useGlobalSpinnerActionsContext();
  const { localization } = useLanguageContext();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(dayjs());
  const [appliedDateRange, setAppliedDateRange] = useState({
    from: null,
    to: null,
  });

  const handleApply = () => {
    setGlobalSpinner(true);
    const payload = {
      PlantId: sessionStorage.getItem("werkId"),
      FromDate: {
        year: fromDate.year(),
        month: fromDate.month() + 1,
        day: fromDate.date(),
      },
      ToDate: {
        year: toDate.year(),
        month: toDate.month() + 1,
        day: toDate.date(),
      },
    };

    if (keyOfChart === "InspectionKpi") {
      GraphDashboardActions.getInspectionKpiDat(payload);
    } else if (keyOfChart === "EquiStatusDistribution") {
      GraphDashboardActions.getDashboardEquipmentStatusDistribution(payload);
    } else if (keyOfChart === "TicketKpi") {
      GraphDashboardActions.getTicketKpiData(payload);
      payload["AnlagegruppeId"] = selectedEquipmentGroupId;
      GraphDashboardActions.getEqupipmentTicketCountKPIData(payload);
    } else if (commonUtils.isUserOrganisationAdmin()) {
      GraphDashboardActions.getOrganisationKpiData(payload);
    }
  };

  return (
    <Box display="flex" flexDirection="row" gap={2} id="chartDateRange">
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          id="datePickerId"
          label={localization.From}
          maxDate={toDate}
          value={fromDate}
          format={DateFormate()}
          onChange={(newValue) => setFromDate(newValue)}
          renderInput={(params) => <TextField {...params} />}
        />
        <DatePicker
          label={localization.to}
          value={toDate}
          format={DateFormate()}
          minDate={fromDate}
          onChange={(newValue) => setToDate(newValue)}
          renderInput={(params) => <TextField {...params} />}
        />
      </LocalizationProvider>
      <Button
        variant="contained"
        color="primary"
        onClick={handleApply}
        disabled={!fromDate || !toDate}
      >
        {localization.apply}
      </Button>
    </Box>
  );
}

function DateFormate() {
  const dateFormat = sessionStorage.getItem("df");
  switch (dateFormat) {
    case "dd.MM.yyyy":
      return "D.M.YYYY";
    case "dd/MM/yyyy":
      return "D/M/YYYY";
    case "MM.dd.yyyy":
      return "M.D.YYYY";
    case "MM/dd/yyyy":
      return "M/D/YYYY";
    case "yyyy.MM.dd":
      return "YYYY/M/D";
    default:
  }
}
